import { render, staticRenderFns } from "./ModelCustomerCustomRequestDone.vue?vue&type=template&id=38224aaa"
import script from "./ModelCustomerCustomRequestDone.vue?vue&type=script&lang=js"
export * from "./ModelCustomerCustomRequestDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports